/*
 * wc-manual-review-note.js
 * ------------------------
 * Injects the "manual-review" reassurance line into the child-PDP
 * gallery, between the main slideshow image and the thumbnail strip
 * below it. Mirrors the inline copy already in the modal slider decks
 * (snippets/wolden-customize-modal.liquid).
 *
 * Gated on body.wc-canvas-child so it only runs on Custom canvas
 * child PDPs — never on parent PDPs or PBN children.
 *
 * Robustness against thumbnail-click flicker: Shopify Horizon's
 * slideshow uses view-transitions when navigating slides, which can
 * tear down our injected note as a side effect. We:
 *   (a) inject into EVERY <media-gallery> instance on the page
 *       (Horizon ships separate mobile + desktop galleries),
 *   (b) wire a MutationObserver per gallery so if the theme removes
 *       our note we re-inject it within the same frame,
 *   (c) rely on the CSS min-height on .wolden-customize__manual-
 *       review-note so the thumbnail strip doesn't shift during the
 *       brief unmount-remount window,
 *   (d) wire a top-level body observer so lazily-mounted galleries
 *       (mobile drawer, tab swap) get the same treatment.
 */
(function () {
  if (window.__wcManualReviewNoteLoaded) return;
  window.__wcManualReviewNoteLoaded = true;

  var TEXT = 'All orders are manually reviewed to balance out any spacing or centering imperfections';
  var ATTR = 'manual-review-note-pdp';

  function makeNote() {
    var p = document.createElement('p');
    p.className = 'wolden-customize__manual-review-note';
    p.setAttribute('data-wc-element', ATTR);
    p.textContent = TEXT;
    return p;
  }

  function injectInto(gallery) {
    if (!gallery || gallery.__wcManualReviewNoteWired) return;
    function inject() {
      if (gallery.querySelector('[data-wc-element="' + ATTR + '"]')) return;
      var note = makeNote();
      // Horizon ships TWO <slideshow-controls> in slideshow mode:
      //   #1 desktop: flowing thumbnail strip — position: static, sits
      //      after the main image in normal layout.
      //   #2 mobile:  absolute-positioned pagination pill (< 1 / 3 >)
      //      that overlays the bottom of the main image.
      // For #1 we want the note BEFORE the strip (between main image
      // and thumbs). For #2 we want the note AFTER <slideshow-
      // component> entirely — placing it inside would land it under
      // the pill overlay and they'd visually collide.
      var slideshow = gallery.querySelector('slideshow-component');
      var visibleControls = Array.from(gallery.querySelectorAll('slideshow-controls'))
        .filter(function (c) {
          var r = c.getBoundingClientRect();
          return r.width > 0 && r.height > 0;
        })[0];
      var isFlowing = visibleControls
        && getComputedStyle(visibleControls).position !== 'absolute'
        && getComputedStyle(visibleControls).position !== 'fixed';
      if (isFlowing && visibleControls.parentNode) {
        // Desktop layout — insert above the flowing thumbnail strip.
        visibleControls.parentNode.insertBefore(note, visibleControls);
        return;
      }
      if (slideshow && slideshow.parentNode) {
        // Mobile layout (or no controls at all) — insert AFTER the
        // slideshow component so the overlay pill stays clear of
        // the note.
        if (slideshow.nextSibling) {
          slideshow.parentNode.insertBefore(note, slideshow.nextSibling);
        } else {
          slideshow.parentNode.appendChild(note);
        }
        return;
      }
      // Final fallback — no slideshow at all, just drop into gallery.
      gallery.appendChild(note);
    }
    inject();
    // Re-inject if the theme's slideshow tears the note out during a
    // slide navigation.
    var obs = new MutationObserver(function () {
      if (!gallery.querySelector('[data-wc-element="' + ATTR + '"]')) {
        inject();
      }
    });
    obs.observe(gallery, { childList: true, subtree: true });
    gallery.__wcManualReviewNoteWired = true;
  }

  function init() {
    // Gate: ANY auto-generated child PDP (Canvas Print, Framed Canvas,
    // PBN Kit). wc-auto-child is set in layout/theme.liquid for every
    // orchestrator-created child plus any product with the
    // original_vs_pet_swap == "Custom" metafield. PBN children are
    // included per operator spec — note should render on all 3 format
    // child PDPs.
    if (!document.body || !document.body.classList.contains('wc-auto-child')) return;
    document.querySelectorAll('media-gallery').forEach(injectInto);
    // Top-level observer for galleries that mount lazily (mobile
    // drawer, tab swap, view-transition rebuild).
    if (window.__wcManualReviewGalleryObserver) return;
    window.__wcManualReviewGalleryObserver = new MutationObserver(function (muts) {
      for (var m = 0; m < muts.length; m++) {
        var added = muts[m].addedNodes;
        for (var n = 0; n < added.length; n++) {
          var node = added[n];
          if (node.nodeType !== 1) continue;
          if (node.tagName && node.tagName.toLowerCase() === 'media-gallery') {
            injectInto(node);
          } else if (node.querySelectorAll) {
            node.querySelectorAll('media-gallery').forEach(injectInto);
          }
        }
      }
    });
    window.__wcManualReviewGalleryObserver.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
